<template>
  <div class="contracts">
    <van-nav-bar
      title="借款合同"
      left-arrow
      safe-area-inset-top
      @click-left="$router.go(-1)"
    />
    <div v-if="list.length">
      <div
        v-for="item in list"
        :key="item.id"
        class="item"
      >
        <div class="row" @click="$router.push(`/contract-detail/${item.id}`)">
          <div>
            <div class="name">{{ item.product_name }}</div>
            <div class="sub">合同号 {{ item.contract_no }}</div>
            <div class="sub">本金 ¥{{ Number(item.principal).toFixed(2) }} · {{ item.term }}期</div>
          </div>
          <van-tag v-if="item.settled" type="success">已结清</van-tag>
          <van-tag v-else :type="item.agreed ? 'primary' : 'warning'">
            {{ item.agreed ? '还款中' : '待确认' }}
          </van-tag>
        </div>
        <div v-if="item.settled" class="actions">
          <van-button
            size="small"
            round
            type="info"
            plain
            @click.stop="$router.push(`/settle-cert/${item.id}`)"
          >查看结清证明</van-button>
        </div>
      </div>
    </div>
    <div class="zero" v-else>
      <img src="../assets/img/zw.png" alt="" />
      <p>暂无合同</p>
    </div>
  </div>
</template>

<script>
import { contracts } from '@/api/request.js'
export default {
  name: 'Contracts',
  data() {
    return { list: [] }
  },
  async mounted() {
    const res = await contracts()
    this.list = res.data || []
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/public";
.contracts {
  min-height: 100%;
  background: #f5f5f5;
  .van-nav-bar {
    background-image: linear-gradient(to right, #6aa8f5, #3d8aef);
    /deep/ .van-nav-bar__title, /deep/ .van-icon { color: #fff; }
  }
  .item {
    margin: .24rem;
    background: #fff;
    border-radius: .2rem;
    padding: .3rem;
    box-shadow: 3px 3px 20px #eee;
  }
  .row { display: flex; justify-content: space-between; align-items: flex-start; }
  .name { font-size: .34rem; font-weight: 600; color: #333; }
  .sub { margin-top: .12rem; color: #888; font-size: .24rem; }
  .actions {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid #f0f0f0;
    text-align: right;
  }
  .zero {
    margin-top: 2rem;
    text-align: center;
    color: #999;
    img { width: 2.48rem; margin: 0 auto .2rem; }
  }
}
</style>
